import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
  userActionTypes as types,
  LoadUserProfileFailsAction,
  LoadUserProfileSuccessAction,
  LoadUserProfileAction,
  UpdateUserProfileAction,
  UpdateUserProfileSuccessAction, UpdateUserProfileFailsAction,
} from './user.actions';
import { UserService } from '../services';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserProfile } from '../models';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Error } from '../../../shared';

@Injectable()
export class UserEffects {

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private toastr: ToastrService,
    private router: Router
  ) {
  }

  loadUserProfile$ = createEffect(() => this.actions$.pipe(
    ofType(types.UserProfile_Load),
    map((action: LoadUserProfileAction) => action.payload),
    mergeMap(() =>
      this.userService.getProfile()
        .pipe(
          map((response: UserProfile) => new LoadUserProfileSuccessAction(response)),
          catchError(error => of(new LoadUserProfileFailsAction(error)))
        )
    )
  )
  );

  updateUserProfile$ = createEffect(() => this.actions$.pipe(
    ofType(types.UpdateProfile),
    map((action: UpdateUserProfileAction) => action.payload),
    mergeMap((request: UserProfile) =>
      this.userService.updateProfile(request)
        .pipe(
          map((response: UserProfile) => new UpdateUserProfileSuccessAction(response)),
          catchError(error => of(new UpdateUserProfileFailsAction(error)))
        )
    )
  )
  );

  updateUserProfileSuccess$ = createEffect(() => this.actions$.pipe(
    ofType(types.UpdateProfile_SUCCESS),
    map(action => (action as UpdateUserProfileSuccessAction).payload),
    tap(() => {
      //this.router.navigateByUrl('/useraccount/user/profile');
      this.toastr.success('Profile Updated');
    }),
    mergeMap(() => [
    ]))
  );


  updateUserProfileFails$ = createEffect(() => this.actions$.pipe(
    ofType(types.UpdateProfile_FAILS),
    map(action => (action as UpdateUserProfileFailsAction).payload),
    tap((response: { error: { errors: Error[] } }) => {
      const msg = (response.error.errors && response.error.errors.length > 0) ? response.error.errors[0]?.details : '';
      this.toastr.error(msg, 'Profile Not Updated', { timeOut: 0, extendedTimeOut: 0 });
    })
  ),
  { dispatch: false }
  );
}
